<template>
    <div class="row login-container">
      <!-- Logo section for mobile view -->
      <div class="col-12 d-md-none mobile-logo text-center">
        <img src="../../../assets/unodc-logo-white.png" class="img-fluid mobile-logo-img mt-2" />
      </div>
  
      <!-- Left section with background image -->
      <div
        class="col-lg-9 col-md-7 col-sm-12 bg d-none d-md-flex"
        :style="{ backgroundImage: 'url(' + require('@/assets/login-bg.jpg') + ')' }"
      >
        <div class="container-fluid">
          <div class="row">
            <div class="col-sm-8 offset-sm-2" style="margin-top: 120px">
              <img src="../../../assets/UNODC-logo-full.png" class="img-responsive tablet-logo" />
              <div class="mt-5">
                <h2 style="text-align: center">
                Add Participants in Event
              </h2>
              </div>
              
            </div>
          </div>
        </div>
      </div>
  
      <!-- Login form section -->
      <div class="col-lg-3 col-md-5 col-sm-12 bg-blue">
        <div class="container-fluid">
          <div class="row">
            <div class="col-sm-12 text-center login-form-container">
              <h6 class="text-white text-uppercase mb-4">login</h6>
              <div class="alert alert-danger" v-if="error">{{ error }}</div>
                <div class="form-group">
                  <input
                    type="text"
                    v-model="trainingCode"
                    class="form-control"
                    placeholder="Event Code"
                    style="height:32px;font-size:14px"
                  />
                </div>
                <div class="form-group">
                  <input
                    v-model="trainingToken"
                    type="password"
                    class="form-control"
                    placeholder="Event Password"
                    style="height:32px;font-size:14px"
                  />
                </div>
  
                <button
                  type="button"
                  class="btn btn-black mt-3 btn-sm"
                  style="padding:3px 60px;"
                  @click="handleLogin"
                >
                  Login
                </button>
  
               
              
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  
  import axios from "axios";
  
  
  export default {
    data() {
      return {
        trainingCode: "",
        trainingToken: "",
        error: "",
        basepath: process.env.VUE_APP_BASE_PATH
      };
    },
    mounted() {
      
    },
    methods: {
      openLoading() {
        this.$vs.loading({
          type: "material"
        });
      },
      closeLoading() {
        this.$vs.loading.close();
      },
      async handleLogin() {
        try {
          this.openLoading();
          const response = await axios.post(this.basepath + '/training/is-training-exist', {
            training_code: this.trainingCode,
            training_token: this.trainingToken
          });
          
          if (response.data) {
            sessionStorage.setItem('trainingInfo', JSON.stringify(response.data));
            this.$router.push('/addParticipants');
          }
        } catch (error) {
          this.error = error.response?.data?.message || 'An error occurred during login';
        } finally {
          this.closeLoading();
        }
      }
    },
  //   created: function() {
  //     if (window.location.href.includes("dev.tmisodc.org")) {
  //        this.basepath = "https://dev.tmisodc.org/dapi";
  //        localStorage.setItem("BASE_PATH", "https://dev.tmisodc.org/dapi");
  //      } else {
  //        this.basepath = "https://tmisodc.org/api";
  //        localStorage.setItem("BASE_PATH", "https://tmisodc.org/api");
  //      }
    
  // }
    
  };
  </script>
  
  <style scoped>
  body,
  html {
    height: 100% !important;
  }
  
  .bg {
    display: inline-flex;
    /* Full height */
    height: 100vh;
    /* Center and scale the image nicely */
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }
  
  .bg-blue {
    /* The image used */
    background-color: #00a6e4;
    float: right;
    /* Full height */
    height: 100vh;
  }
  
  .btn-black {
    background-color: #354146 !important;
    color: #fff !important;
  }
  
  ::placeholder {
    text-align: center;
    color: #cdcdcd !important;
  }
  
  .login-container {
    overflow-y: auto;
    height: 100vh;
    margin: 0;
  }
  
  .mobile-logo {
    background-color: #00a6e4;
    padding: 20px 0;
  }
  
  .mobile-logo-img {
    max-width: 280px;
    margin: 0 auto;
  }
  
  .login-form-container {
    margin-top: 30px;
  }
  
  @media (min-width: 768px) {
    .login-form-container {
      margin-top: 110px;
    }
  }
  
  /* Adjust form inputs for better mobile experience */
  .form-control {
    max-width: 280px;
    margin: 0 auto;
  }
  
  /* Adjust button for mobile */
  .btn-black {
    width: 200px;
    margin: 0 auto;
  }
  
  /* Tablet-specific styles */
  @media (min-width: 768px) and (max-width: 1024px) {
    .tablet-logo {
      width: 340px !important;
      max-width: 100%;
    }
  
    .tablet-title {
      font-size: 1.5rem;
      margin-top: 1rem;
    }
  
    .login-form-container {
      margin-top: 80px;
    }
  
    .form-control {
      max-width: 240px;
    }
  
    .btn-black {
      width: 160px;
      font-size: 0.9rem;
    }
  }
  
  /* Update existing responsive styles */
  .login-form-container {
    margin-top: 30px;
  }
  
  @media (min-width: 1025px) {
    .login-form-container {
      margin-top: 110px;
    }
  }
  
  /* Adjust the existing logo styles */
  .tablet-logo {
    width: 460px;
    max-width: 100%;
  }
   
  </style>
  